module.exports=[
  {
    "name": "Architecting a history pipeline",
    "url": "/history",
    "date": "2018-02-13"
  },
  {
    "name": "Browser Application State",
    "url": "/browser-state",
    "date": "2018-04-09"
  },
  {
    "name": "Software as Gardening",
    "url": "/software-gardening",
    "date": "2018-04-28"
  },
  {
    "name": "Rust Won't Save You From All Bugs",
    "url": "/rust-bugs",
    "date": "2018-08-10"
  }
]
